module.exports = __webpack_public_path__ + "807a4dce4eb920eeef6daeef57c65b4b.jpg";